// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"cee37d89","976":"e6f1ed96"}[chunkId] + ".chunk.css";
};